
/**
 * @file 任务筛选
 * @author sunyingying01
 */
import React, {useCallback} from 'react';
import cx from 'classnames';
import {observer} from 'mobx-react-lite';
import {IconMap} from '@/components/IconMap';
import {JobsListStore} from '@/stores';
import styles from './index.module.less';

interface FilterProps {
    statusOptions: FiltetStatusOptionsType[];
    onFilter: (value: FiltetStatusOptionsType) => void;
    store: JobsListStore;
}

const JobFilter: React.FC<FilterProps> = observer(({statusOptions, onFilter, store}) => {

    /** 点击筛选 */
    const handleFilter = useCallback(
        (val: FiltetStatusOptionsType) => {
            onFilter?.(val);
        },
        [onFilter]
    );

    return (
        <div className={styles.filterWrapper}>
            {statusOptions.map(item => (
                <div
                    className={cx(styles.filterItem, {
                        [styles.filterItemActive]: store.filterStatus.status === item.status,
                        [styles.filterItemDisabled]: store.countTasksByStatusNumber[item.status] === 0
                    })}
                    key={item.label}
                    onClick={store.countTasksByStatusNumber[item.status] === 0 ? undefined : () => handleFilter(item)}
                >
                    <div className={styles.item}>
                        {IconMap[item.status] && (
                            <div className={styles.icon}>
                                {IconMap[item.status]}
                            </div>
                        )}
                        <span>{item.label}</span>
                    </div>
                    <span className={styles.filterValue}>{store.countTasksByStatusNumber[item.status]}</span>
                </div>
            ))}
        </div>
    );
});

export default JobFilter;
